import { useEffect, useState } from 'react';
import api from '../api/apiClient';
import PageHeader from '../components/PageHeader';
import useAuth from '../hooks/useAuth';

export default function DashboardPage() {
  const { currentBranch, user } = useAuth();
  const [dashboard, setDashboard] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    async function loadDashboard() {
      try {
        const params = {};
        if (currentBranch?.branch_id) {
          params.branch_id = currentBranch.branch_id;
        }
        const response = await api.get('/admin/dashboard', { params });
        setDashboard(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Unable to load dashboard');
      }
    }

    loadDashboard();
  }, [currentBranch]);

  const totals = dashboard?.totals || {};
  const attendance = dashboard?.attendance || {};
  const activeBranchName = currentBranch?.name || dashboard?.branch_name || 'All Branches';

  // For Super Admin (when no specific branch is selected), show Total Branches count.
  // For Center Manager or when a specific branch is selected, show Branch Name.
  const isCenterManager = user?.role === 'center_manager' || !!currentBranch;

  const branchCard = isCenterManager
    ? { label: 'Branch Name', value: activeBranchName }
    : { label: 'Total branches', value: totals.branches || 0 };

  const summary = [
    branchCard,
    { label: 'Total teachers', value: totals.teachers || 0 },
    { label: 'Total parents', value: totals.parents || 0 },
    { label: 'Total students', value: totals.students || 0 },
    { label: 'Pending approvals', value: totals.pending_approvals || 0 },
  ];

  return (
    <div>
      <PageHeader title="Dashboard" subtitle="Admin control center" />
      {error && <div className="error-message">{error}</div>}

      <div className="dashboard-grid">
        {summary.map((card) => (
          <div key={card.label} className="summary-card">
            <p>{card.label}</p>
            <strong>{card.value}</strong>
          </div>
        ))}
      </div>

      <section className="dashboard-section">
        <h3>Attendance summary</h3>
        <div className="quick-links-grid">
          {['present', 'absent', 'late', 'unmarked'].map((key) => (
            <div className="quick-link" key={key}>
              <span className="muted-label">{key}</span>
              <strong>{attendance[key] || 0}</strong>
            </div>
          ))}
        </div>
      </section>

      <section className="dashboard-section">
        <h3>Recent activities</h3>
        <div className="quick-links-grid">
          {(dashboard?.recent_activities || []).map((activity) => (
            <div className="quick-link" key={activity.id}>
              <strong>{activity.title || activity.category}</strong>
              <p>{activity.teacher_name || '-'} / {activity.branch_name || '-'}</p>
            </div>
          ))}
          {!dashboard?.recent_activities?.length && <div className="quick-link">No recent activities.</div>}
        </div>
      </section>
    </div>
  );
}
